<template>
  <leave-utilization-report type="Leave Utilization Report">
  </leave-utilization-report>
</template>

<script>
import LeaveUtilizationReport from "./LeaveUtilizationReport.vue";
export default {
  components: {
    LeaveUtilizationReport,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/LeaveUtilizationReport/AdminLeaveUtilizationReport.vue